import axios from 'axios';

export default class TitulosProblematicosService {
    constructor(http, store) {
        this._http = http;
        this._store = store;
    }

    async listarTitulosProblematicos(page, perPage) {
        try {
            const response = await axios.get(
                process.env.VUE_APP_RECUPERI_API + 'titulos/envios-problematicos',
                {
                    params: {
                        page: page,
                        per_page: perPage
                    },
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async reenviarTitulos(titulos) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_RECUPERI_API + 'titulos/envios-problematicos',
                {
                    titulos: titulos.map(t => ({
                        id_titulo: t.id_titulo,
                        cd_apresentante: t.cd_apresentante || this._store.getters.cdApresentante
                    }))
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }
}
